<template>
  <div>
    <div class="cake-layout">
      <CacheRouterView />
    </div>
  </div>
</template>
<script>
import CacheRouterView from '@/components/CacheRouterView'

// import layoutTabbar from '@/components/Tabbar.vue'

export default {
  name: 'Cake',
  components: {
    // layoutTabbar
    CacheRouterView
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.cake-layout {
  // padding-bottom: 1rem;
  background: $cake-primary-bg;
  min-height: calc(100vh - 1rem);
}
</style>
